import React from 'react'
import './ErrMsg.scss'

const ErrMsg = (props: any) => (
    <div className='errMsg' role="alert" aria-live="assertive">
        <div className='errDiv'>
            <p className='msg'>
                {props.children}
            </p>
        </div>
    </div>
)

export default ErrMsg
